import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { IAdminLogin } from '../../../../constants/interfaces';
import { validateDataToSend } from './functions';

import {
  Wrapper,
  Heading,
  InputWrapperRow,
  Error,
  LoginButton,
} from './Styles';
import { adminLoginApi } from './../../../../apis/index';
import { handleScrollToTop } from '../../../../utils/handleScrollToTop';

const AdminLogin = () => {
  const navigate = useNavigate();

  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [dataToSend, setDataToSend] = useState<IAdminLogin>({
    email: '',
    password: '',
  });

  const changeHandler = (e: any) => {
    setError('');
    setDataToSend((prevState: any) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = async () => {
    if (validateDataToSend(dataToSend, setError)) {
      try {
        setIsLoading(true);
        await adminLoginApi(dataToSend);
        navigate('/admin/dashboard');
        setIsLoading(false);
      } catch (error: any) {
        setIsLoading(false);
        console.log(error.response.data.message);
        setError(error.response.data.message || 'Something went wrong.');
      }
    }
  };

  useEffect(() => {
    handleScrollToTop();
  }, []);

  return (
    <Wrapper>
      <Heading>Admin Login</Heading>
      <InputWrapperRow>
        <input
          type="text"
          placeholder="Enter admin email"
          name="email"
          onChange={changeHandler}
        />
      </InputWrapperRow>
      <InputWrapperRow>
        <input
          type="password"
          placeholder="Enter admin password"
          name="password"
          onChange={changeHandler}
        />
      </InputWrapperRow>
      {!!error && <Error>{error}</Error>}
      <LoginButton onClick={handleSubmit}>
        {isLoading ? 'Processing...' : 'Login'}
      </LoginButton>
    </Wrapper>
  );
};

export default AdminLogin;
